import React from "react";

const ListItem: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <>
      {children}
    </>
  );
}

export default ListItem;